const STATS = [
  { value: '5000+', label: '高清影片' },
  { value: '每日更新', label: '片源不断' },
  { value: '极速播放', label: '流畅不缓冲' },
];

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20background%20with%20soft%20warm%20amber%20spotlight%20rays%20cutting%20through%20deep%20shadows%2C%20abstract%20geometric%20composition%2C%20elegant%20minimalist%20atmosphere%2C%20film%20reel%20textures%20subtle%20in%20background%2C%20warm%20golden%20and%20deep%20charcoal%20tones%2C%204K%20cinematic%20quality&width=1920&height=1080&seq=hero-bg-movie-01&orientation=landscape"
          alt="97影视电影背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/60 via-transparent to-background-50/30" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-24 md:py-32 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex flex-wrap items-center gap-2 justify-center lg:justify-start mb-5">
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-500/20 text-accent-400 border border-accent-500/30">
                最新电影
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-500/20 text-primary-400 border border-primary-500/30">
                高清画质
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/20 text-secondary-400 border border-secondary-500/30">
                极速播放
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-2">
              97影视
            </h1>
            <p className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-2">
              海量高清电影免费在线观看
            </p>
            <p className="text-base sm:text-lg text-primary-500 font-medium mb-6">
              每日更新，精彩不停 — 动作片、喜剧片一网打尽
            </p>

            <p className="text-sm sm:text-base text-foreground-500 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              97影视为您精心挑选海量电影资源，涵盖最新<strong>动作片</strong>、爆笑<strong>喜剧片</strong>、经典科幻、温情剧情等丰富类型。片源每日更新，高清画质搭配极速播放引擎，无需等待、无需付费，即刻畅享沉浸式观影体验。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8 justify-center lg:justify-start">
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-xl md:text-2xl font-heading font-bold text-primary-500">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg" />
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300/60 hover:border-primary-500/50 text-foreground-700 hover:text-primary-500 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg" />
                热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden aspect-[4/5] max-w-sm mx-auto lg:max-w-none">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20dramatic%20lighting%2C%20action%20film%20silhouettes%20blended%20with%20warm%20golden%20and%20deep%20red%20gradients%2C%20film%20strip%20border%20elements%2C%20movie%20clapperboard%20silhouette%2C%20epic%20cinematic%20composition%20with%20lens%20flares%20and%20atmospheric%20smoke%2C%20dark%20rich%20tones&width=800&height=1000&seq=hero-poster-01&orientation=portrait"
                alt="97影视 - 海量高清电影"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 rounded-lg bg-gradient-to-t from-background-50/40 to-transparent pointer-events-none" />
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2 text-xs text-foreground-800 bg-background-100/80 backdrop-blur-sm rounded-md px-3 py-2">
                  <i className="ri-movie-line text-primary-500" />
                  <span>每日更新 · 高清画质 · 极速播放</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}